<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="用户名称" prop="name">
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户账号:" prop="account">
          <el-input
            clearable
            v-model.trim="table.params.account"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="消耗日期:" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <VTable
      has-pagionation
      title=""
      addText="添加"
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :hasPagionation="true"
      :default-expand-all="true"
      :showOverflowTooltip="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:action="{ row }">
        <el-button type="text" @click="viewDetail(row)">查看明细</el-button>
      </template>
    </VTable>
    <scoreRankingDialog ref="scoreRankingDialogRef"></scoreRankingDialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import scoreRankingDialog from "./components/scoreRankingDialog.vue";
export default {
  name: "UserList",
  components: {
    VTable,
    scoreRankingDialog,
  },
  mixins: [mixinTable],
  data() {
    return {
      field: [
        { name: "nickname", label: "用户名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "total_integral", label: "获赠积分", hidden: false },
        { name: "expend_integral", label: "消耗积分", hidden: false },
        { name: "integral", label: "剩余积分", hidden: false },
        { name: "integral_time", label: "更新时间", hidden: false },
        {
          name: "action",
          label: "操作",
          hidden: false,
          width: 120,
          fixed: "right",
        },
      ],
      table: {
        loading: false,
        params: {
          name: "",
          account: "",
          date: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    viewDetail(row) {
      let dom = this.$refs.scoreRankingDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    getTable() {
      let _params = { ...this.table.params };
      delete _params.area_arr;
      this.$http
        .get("/admin/flex_trade/rank", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 查看
    showDetail(row, userType) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row, userType);
      dom = null;
    },
    // 关闭
    handleClose() {
      this.$confirm("是否关闭此条记录？", "删除", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
          } else {
            done();
          }
        },
      }).catch(() => {});
    },
    // 删除
    remove(row) {
      this.$confirm("是否删除此条记录？", "删除", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.delete(row.id);
            done();
          } else {
            done();
          }
        },
      }).catch(() => {});
    },
    delete(rowid) {
      this.$http.post("/admin/article/delete", { id: rowid }).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功！");
          this.getTable();
        } else {
          this.$message.error(res.data);
        }
      });
    },
  },
};
</script>